<template>
	<div class="flex_1 margin_horizontal">
		<AccessRestrictedTabs class="table_tabs"
							  v-model="activeTab"
							  :elements="tabTypes"
							  :session-key="$route.path"
		/>
		<DebtorIpuTableWithFilter v-if="activeTab === tabTypes.ipuConfirmations"/>
	</div>
</template>
<script>

import DebtorIpuTableWithFilter from "@/components/templates/debtor/DebtorIpuTableWithFilter.vue";
import AccessRestrictedTabs from "@/components/templates/common/permissions/AccessRestrictedTabs";
import {enumDef} from "@/common/enumDefs";
import {navigationTabs} from "@/common/navigation/navigationTabs";

export default {
	components: { DebtorIpuTableWithFilter, AccessRestrictedTabs },
	data() {
		let tabTypes = {
			ipuConfirmations: {
				name: navigationTabs.debtor.ipu,
				translationKey: "debtor.ipuConfirmation.title",
				permission: enumDef.permissions.DebtorIpuConfirmations
			}
		};

		return {
			tabTypes: tabTypes,
			activeTab: null,
		};
	},
};
</script>
